import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import classNames from "classnames";
import dompurify from "isomorphic-dompurify";
import { Tier } from "./Tier/Tier";
import { TierStatus } from "./TierStatus/TierStatus";
import styles from "./TierBenefits.module.scss";
const { sanitize } = dompurify;
export const TiersBenefits = ({ general, tier1, tier2, tier3, benefitsSections = [], icons, componentId, }) => {
    const ACTIVE_CLASS = "active";
    const handleMobileTierChange = (entries, tiersSection) => {
        entries.forEach((entry) => {
            const currentTierId = entry.target.attributes?.getNamedItem("data-tierid")?.value;
            const tierTableItems = tiersSection?.querySelectorAll(`[data-tierid='${currentTierId}']`);
            tierTableItems?.forEach((item) => {
                const { isIntersecting } = entry;
                item.classList.toggle(ACTIVE_CLASS, isIntersecting);
                entry.target.classList.toggle(ACTIVE_CLASS, isIntersecting);
            });
        });
    };
    useEffect(() => {
        const tierBenefits = document.getElementById(componentId);
        if (!tierBenefits)
            return;
        const tiers = Array.from(tierBenefits.querySelectorAll(".tierItem"));
        const tiersSection = tierBenefits.querySelector(`.${styles.sectionWrapper}`);
        const options = {
            root: tierBenefits.querySelector(`.${styles.tiersSection}`),
            threshold: 1,
        };
        const observer = new IntersectionObserver((entries) => handleMobileTierChange(entries, tiersSection), options);
        tiers.forEach((tier) => observer.observe(tier));
        // Should only run once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { name, description, background } = general;
    const benefitItemClasses = classNames(styles.sectionItemStatus, styles.tableBorder);
    return (_jsxs("div", { className: styles.tierBenefits, id: componentId, children: [_jsxs("div", { className: styles.heading, children: [_jsx("h2", { children: name }), !!description && _jsx("div", { dangerouslySetInnerHTML: { __html: sanitize(description) } })] }), _jsx("div", { className: styles.tiersSection, children: [tier1, tier2, tier3].map(({ name, description, asset, altText }, index) => (_jsx(Tier, { name: name, description: description, asset: asset, altText: altText, id: index }, name))) }), _jsx("div", { className: styles.table, style: {
                    backgroundImage: `url(${background})`,
                }, children: _jsx("div", { className: styles.sectionWrapper, children: benefitsSections.map(({ name, benefits }) => (_jsxs("div", { className: styles.section, "data-testid": "tierBenefitsSection", children: [_jsx("div", { className: styles.title, children: _jsx("div", { className: styles.titleContent, children: name }) }), benefits.map(({ name, tier1Label, tier1State, tier2Label, tier2State, tier3Label, tier3State, isHighLightened }) => {
                                const commonProps = {
                                    confirmIcon: icons.confirmIcon,
                                    denyIcon: icons.denyIcon,
                                    isHighLightened,
                                };
                                return (_jsxs("div", { className: styles.sectionItem, "data-testid": "tierBenefitsItem", children: [_jsx("div", { className: styles.sectionItemName, children: name }), _jsx("div", { className: styles.sectionItemStatus, "data-tierid": 0, children: _jsx(TierStatus, { ...commonProps, status: tier1State, label: tier1Label }) }), _jsx("div", { className: benefitItemClasses, "data-tierid": 1, children: _jsx(TierStatus, { ...commonProps, status: tier2State, label: tier2Label }) }), _jsx("div", { className: benefitItemClasses, "data-tierid": 2, children: _jsx(TierStatus, { status: tier3State, label: tier3Label, ...commonProps }) })] }, name));
                            })] }, name))) }) })] }));
};
//# sourceMappingURL=TiersBenefits.js.map